import React, { useContext } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

import DecommissioningReportContext from '@totem/components/salesOrders/decommissioning/DecommissioningReportContext';

const styles = {
  searchContainer: {
    marginBottom: '0.5rem',
  },
  search: {
    width: '240px',
  },
};

const DecommissioningReportFilters = () => {
  const { searchText, setSearchText } = useContext(
    DecommissioningReportContext,
  );

  return (
    <div style={styles.searchContainer}>
      <Input
        prefix={<SearchOutlined />}
        placeholder="Search device names..."
        style={styles.search}
        value={searchText}
        onChange={(evt) => setSearchText(evt.target.value)}
        allowClear
      />
    </div>
  );
};

export default DecommissioningReportFilters;
